module.exports = __webpack_public_path__ + "static/media/category-banner.9a6b37c7.png";